const SENTRY_ENVIRONMENTS = ['demo', 'dev', 'pre-prod', 'prod'];

let sentryInitialized = false;

/** Load Sentry after initial paint — not on the critical path. */
export function initDeferredSentry() {
  if (sentryInitialized) return;

  const shouldInit =
    import.meta.env.VITE_GLITCHTIP_DSN &&
    import.meta.env.VITE_ENV_NAME &&
    SENTRY_ENVIRONMENTS.includes(import.meta.env.VITE_ENV_NAME);

  if (!shouldInit) return;

  sentryInitialized = true;

  void import('@sentry/browser').then((Sentry) => {
    Sentry.init({
      dsn: import.meta.env.VITE_GLITCHTIP_DSN,
      environment: import.meta.env.VITE_ENV_NAME,
      tracesSampleRate: 1.0,
    });
  });
}
